import { styled, css } from 'styled-components';
import { Media } from '../../../theme/Media.js';
import { TableCellContentType } from './components/TableCell/types.js';
import { TableRowRole } from './components/TableRow/types.js';
export const TableWrapper = styled.div `
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  ${({ theme, $inner }) => $inner
    ? css `
          border: 1px solid ${theme.colors.grey10_1};
        `
    : theme.shadows.small}
`;
export const TableBody = styled.tbody `
  @media ${Media.xsMax} {
    display: block;
  }
`;
export const TableScrollableWrapper = styled.div `
  position: relative;
  overflow-x: auto;

  ${({ theme, $compact }) => $compact &&
    css `
      border: 1px solid ${theme.colors.grey30_1};
      border-radius: 8px;
    `}

  @media ${Media.smMin} {
    ${({ $maxHeight }) => $maxHeight &&
    css `
        overflow-y: auto;
        max-height: ${$maxHeight}px;
      `}
  }
`;
export const StyledTable = styled.table `
  width: 100%;
  border-collapse: separate;

  @media ${Media.smMin} {
    // The group marker gets room beside the first column instead of covering it. Every plain and group
    // row of a table with groups gets it, as does the header, so all of them stay aligned; the group tab
    // sits right above the marker and is left out. An expanded panel gets it only in a group row, where
    // the marker runs along it
    &:has(> tbody[data-row-role='${TableRowRole.GROUP_ELEMENT}']) {
      & > thead > tr > :first-child,
      & > tbody[data-row-role='${TableRowRole.DEFAULT}'] > tr:first-child > :first-child,
      & > tbody[data-row-role='${TableRowRole.GROUP_ELEMENT}'] > tr > :first-child {
        border-left: 8px solid transparent;
      }

      // A sticky checkbox cell stays put on horizontal scroll while the marker scrolls away with its row,
      // so in a group row the cell carries the marker itself
      & > tbody[data-row-role='${TableRowRole.GROUP_ELEMENT}'] > tr > td[data-content-type='${TableCellContentType.CHECKBOX}']:first-child {
        border-left-color: ${({ theme }) => theme.colors.lightBlue30};
      }
    }
  }

  @media ${Media.xsMax} {
    display: flex;
    flex-direction: column;
  }
`;
